module.exports = __webpack_public_path__ + "static/media/E32.adeaec84.png";